export const buffEffects = {
  stealth: {
    primitives: ['invisibleToOpponents'],
    resources: {}
  },
  unbreakable: {
    primitives: ['damageImmune'],
    resources: {}
  },
  buffArmourElec: {
    primitives: ['scaleArmourElec'],
    resources: {}
  },
  buffArmourMech: {
    primitives: ['scaleArmourMech'],
    resources: {}
  },
  secureInput: {
    primitives: ['secureMove', 'securePartSkills', 'secureRoleSkills'],
    resources: {}
  },
  sumCoreSkillSpeedScalar: {
    primitives: ['sumCoreSkillSpeedScalar'],
    resources: {}
  },
  sumCoreSkillPowerRaw: {
    primitives: ['sumCoreSkillPower'],
    resources: {}
  }
} as const;
